import { Button, Stack, Typography } from '@mui/material'
import { FC, useContext, useState } from 'react'

import { RepairOrderContext } from '../../../providers/RepairOrderProvider/RepairOrderProvider'
import formatMdyDate from '../../../utils/formatMdyDate/formatMdyDate'
import CloseDateDialog from '../CloseDate/CloseDateDialog'

const CloseDate: FC = () => {
  const { repairOrder } = useContext(RepairOrderContext)
  const closedOn = repairOrder?.entry?.info?.closedOn
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  return (
    <>
      <CloseDateDialog
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
      />
      {repairOrder && closedOn && (
        <Stack direction="row" spacing={1}>
          <Typography sx={{ fontWeight: 'bold' }}>Closed Date:</Typography>
          <Typography>{formatMdyDate(closedOn)}</Typography>
          <Button
            size="small"
            onClick={() => setDialogOpen(true)}
            sx={{ height: '1.5rem' }}>
            Edit
          </Button>
        </Stack>
      )}
    </>
  )
}

export default CloseDate
